/* eslint-disable camelcase */
import type { DateRange } from '@hotjar/global-filters';
import { DATE_RANGE_TYPE } from '@hotjar/global-filters';
import type { AbsoluteDateFilterDto, RelativeDateFilterDto } from '../filters/FiltersMappings';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';

export function toISOStringWithNoTimezone(date: Date): string {
  return date.toISOString().slice(0, 19);
}

export function dateFilterConverter(
  filterValue: DateRange | undefined,
): AbsoluteDateFilterDto | RelativeDateFilterDto | undefined {
  if (!filterValue) return undefined;
  switch (filterValue.type) {
    case DATE_RANGE_TYPE.ABSOLUTE:
      return {
        type: IncomingFeedbackDtoFilters.DATE_ABSOLUTE,
        date_from: toISOStringWithNoTimezone(filterValue.from),
        date_to: toISOStringWithNoTimezone(filterValue.to),
      };
    case DATE_RANGE_TYPE.RELATIVE:
      return {
        type: IncomingFeedbackDtoFilters.DATE_RELATIVE,
        unit: filterValue.unit,
        value: filterValue.amount,
      };
    case DATE_RANGE_TYPE.ALL:
      return undefined;
  }
}
